import { Typography, Grid, Divider, Chip, Box } from "@mui/material";
import { useFormContext } from "react-hook-form";
import AppCheckBox from "../../app/components/AppCheckBox";
import AppTextInput from "../../app/components/AppTextInput"
import countryList from 'react-select-country-list'
import { useEffect, useMemo } from "react";
import AppSelectList from "../../app/components/AppSelectList";
import AddressSearch from "./AddressSearch";

interface Props {
  setShippingOption: (state: string) => void
  setIsRural: (state: boolean) => void
  setIsInternational: (state: boolean) => void
}

export default function AddressForm({setIsRural, setIsInternational, setShippingOption} : Props) {
  
  const {control, formState, getValues} = useFormContext()
  const countryWithLabel = useMemo(() => countryList().getData(), [])
  const countries = countryWithLabel.map((country) => country.label)
  let formValues = getValues()
  
  useEffect(() => {
    
    if (formValues.country !== '' && formValues.country !== 'New Zealand') {
        setIsInternational(true)
        
    } 
    else {
      setIsInternational(false)
    }
    setShippingOption(formValues.shippingOption)

  }, [formValues.country, setIsInternational, formValues, setShippingOption])
  
  

  return (
    <>
          <Typography variant="h6" gutterBottom>
            Shipping address
          </Typography>
          <Box sx={{mb: 4}}>
              <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <AppTextInput control={control} name='fullName' label='Full name (required)'
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <AppTextInput control={control} name='phoneNumber' label='Phone number (required)'
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <AddressSearch setIsRural={setIsRural} 
                    />
                    <Typography variant="body2" sx={{ml: 2, mt: 1}}>Note: 
                    </Typography>
                    <Typography variant="body2" sx={{ml: 2, mt: 1}}> 1. You can search your address in this search bar and the address form below will be automatically filled.
                    </Typography>
                    <Typography variant="body2" sx={{ml: 2, mt: 1}}>
                    2. Only New Zealand addresses can be searched in the above search bar.</Typography>
                  </Grid>
              </Grid>
          </Box>
          <Divider sx={{mb: 4}}>
              <Chip label="If you cannot find your address in the above search bar, please type your address below" />
          </Divider>
          <Box>
              <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <AppTextInput control={control} name='address1' label='Address 1 (required)'
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <AppTextInput control={control} name='address2' label='Address 2'
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <AppTextInput control={control} name='city' label='City (required)'
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <AppTextInput control={control} name='region' label='Region'
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <AppTextInput control={control} name='postCode' label='postal Code (required)'
                    />
                  </Grid>
                  {/* <Grid item xs={12} sm={6}>
                    <AppTextInput control={control} name='country' label='Country'
                    />
                  </Grid> */}
                  <Grid item xs={12} sm={6}>
                      <AppSelectList control={control} items={countries} name='country' label='Country (required)' testId="country"/>
                  </Grid>
                  {/* <Grid item xs={12} sm={6}>
                      <AppSelectList control={control} items={['Yes', 'No']} name='ruralAddress' label='Is it a rural address' />
                  </Grid> */}
                  <Grid item xs={6}>
                    <AppSelectList
                        label='Shipping option (required)' 
                        items={['Courier Post', 'Courier Post with signature required']}
                        name='shippingOption'
                        control={control}
                        testId='shippingOption'
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <AppCheckBox
                        disabled={!formState.isDirty}
                        name='saveAddress' 
                        label='Save this as the default address' 
                        control={control}
                    />
                  </Grid>
              </Grid>
          </Box>
    </>
  );
}